var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1246(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M453.932,365.318c-5.351,27.003 -8.47,49.498 -8.47,77.981c0,166.143 97.44,312.688 217.458,374.664c-167.231,0 -312.379,-82.713 -384.053,-203.534l-2.581,3.335c-58.808,23.529 -117.031,69.668 -116.177,183.469c1.177,156.777 170.402,169.904 170.402,169.904l560.223,0.217c0,-0 195.695,-22.573 198.553,-231.768c3.007,-220.119 -210.356,-233.86 -216.109,-244.859c-42.731,-81.699 -71.782,-191.83 -259.168,-192.996c-71.41,-0.444 -121.246,24.957 -160.078,63.587Z",
    style: {
      fill: "#525252"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.534,603.967l4.787,-3.612c-64.53,25.819 -128.899,76.144 -127.962,201.018c1.301,173.294 187.701,188.458 187.701,188.458c0.481,0.037 0.962,0.056 1.443,0.056l560.224,0.217c0.721,-0 1.44,-0.041 2.156,-0.124c0,0 212.063,-23.977 215.152,-250.138c2.881,-210.875 -178.38,-245.975 -221.036,-259.215c-25.632,-50.132 -48.4,-108.78 -101.849,-148.973c-37.795,-28.42 -90.763,-48.173 -171.023,-48.672c-77.386,-0.482 -131.337,27.181 -173.419,69.043c-2.644,2.63 -4.444,5.99 -5.169,9.648c-5.6,28.265 -8.827,51.813 -8.827,81.626c0,143.959 70.25,273.696 165.749,350.744c-129.806,-19.264 -239.144,-90.862 -297.468,-189.18l-16.126,28.316l-14.333,-29.212Zm8.079,35.768c77.653,117.404 223.298,196.978 390.307,196.978c8.65,0 16.178,-5.918 18.22,-14.323c2.042,-8.406 -1.931,-17.118 -9.617,-21.087c-114.615,-59.185 -207.311,-199.341 -207.311,-358.004c0,-25.123 2.578,-45.356 7.003,-68.631l0.004,-0.004c34.991,-33.16 79.703,-54.575 142.675,-54.183c69.649,0.433 115.92,16.482 148.718,41.145c50.509,37.981 69.493,95.027 93.952,141.791c1.421,2.718 4.104,6.354 9.463,9.207c4.038,2.15 13.659,4.938 27.039,8.708c53.155,14.977 179.698,55.126 177.473,217.998c-2.514,184.024 -166.965,211.278 -181,213.27c-28.304,-0.008 -535.52,-0.204 -558.234,-0.212c-11.053,-1.015 -151.435,-16.542 -152.447,-151.296c-0.719,-95.845 44.566,-138.786 93.755,-161.357Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M662.92,68.635c-238.249,0 -431.678,167.882 -431.678,374.664c0,206.783 193.429,374.664 431.678,374.664c-120.018,-61.976 -217.458,-208.521 -217.458,-374.664c0,-166.142 97.44,-312.688 217.458,-374.664Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "37.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.023,1044.01l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.122,1044.01l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.232,1044.01l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.894,1044.01l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.65,1044.01l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.924,1044.01l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1246);
export default __webpack_public_path__ + "static/media/1246.decfb3d3aa27da3811ae6187203c314c.svg";
export { ForwardRef as ReactComponent };